<template>

    <div v-if="isDashboard">

        <!-- Begin page -->
        <div id="layout-wrapper">

            <header id="page-topbar" style="z-index: 150">
                <div class="navbar-header">
                    <div class="d-flex">
                        <!-- LOGO -->
                        <div class="navbar-brand-box">
                            <a href="/" class="logo logo-dark">
                                 <span class="logo-sm">
                                    <img src="../../public/mineimages/logo_blanc_to_text.png" alt="" height="20">
                                </span>
                                <span class="logo-lg">
                                    <img src="../../public/mineimages/logo_line_blanc.png" alt="" height="75">
                                </span>
                            </a>

                            <a href="/" class="logo logo-light">
                                  <span class="logo-sm">
                                    <img src="../../public/mineimages/logo_blanc_to_text.png" alt="" height="20">
                                </span>
                                <span class="logo-lg">
                                    <img src="../../public/mineimages/logo_line_blanc.png" alt="" height="75">
                                </span>
                            </a>
                        </div>

                        <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect"
                                id="vertical-menu-bt" @click="menuAction()">
                            <i class="fa fa-fw fa-bars"></i>
                        </button>

                      
                               
                               <v-row style="margin-top: 1.5%;" v-if="user!=null">


                                    <v-col md="12" sm="12"  style="font-size:15pt; color:#096B97; font-weight:bold; ">
                                       

                                        <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
       
         <span   v-bind="attrs"
          v-on="on" style="margin-top: 9%" v-if="user.relation!=null" color="green" dark>
          <span @click="reloadpage()"> {{ user.relation.nom }}  </span> </span>
                                        <span  v-bind="attrs"
          v-on="on" style="margin-right: 15px;margin-top: 5%;"  v-else   dark >Administrateur</span>
      </template>
      <span style="text-align:center" >Administrer votre pharmacie <br> à travers cet espace</span>
    </v-tooltip>


                                    </v-col>


                               </v-row>

                            


                    </div>

                    <div class="d-flex">


                        <div class="dropdown d-inline-block">
                            <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <img class="rounded-circle header-profile-user" src="../../public/mineimages/avatar.png"
                                     alt="avatar">
                                     <span class="ml-1" v-if="user!=null">{{user.name}}</span>
                                
                                <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                                <!-- item-->
                                <a class="dropdown-item" href="#"> <router-link to="/profil"
                                                     class="dropdown-item">
                                         <i
                                        class="bx bx-user font-size-16 align-middle mr-2 " style="margin-left:-30%"></i>   Profile </router-link></a>
                                
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item text-danger" href="#" @click.prevent="logout"><i
                                        class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Se
                                    déconnecter</a>
                            </div>
                        </div>


                    </div>
                </div>
            </header> <!-- ========== Left Sidebar Start ========== -->
            <div class="vertical-menu">

                <div data-simplebar class="h-100">
                    <Menu/>
                </div>
            </div>
            <!-- Left Sidebar End -->

            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="main-content">

                <router-view @checkisDashboard="checkisDashboard"></router-view>


                <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                            </div>
                            <div class="col-sm-6">
                                <div class="text-sm-right d-none d-sm-block">
                                    Design & Develop by SunTech - SunCare
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
            <!-- end main content-->

        </div>
        <!-- END layout-wrapper -->

        <!-- Right Sidebar -->
        <div class="right-bar">
            <div data-simplebar class="h-100">
                <div class="rightbar-title px-3 py-4">
                    <a href="javascript:void(0);" class="right-bar-toggle float-right">
                        <i class="mdi mdi-close noti-icon"></i>
                    </a>
                    <h5 class="m-0">Settings</h5>
                </div>

                <!-- Settings -->
                <hr class="mt-0"/>
                <h6 class="text-center mb-0">Choose Layouts</h6>

                <div class="p-4">
                    <div class="mb-2">
                        <img src="assets/images/layouts/layout-1.jpg" class="img-fluid img-thumbnail" alt="">
                    </div>
                    <div class="custom-control custom-switch mb-3">
                        <input type="checkbox" class="custom-control-input theme-choice" id="light-mode-switch"
                               checked/>
                        <label class="custom-control-label" for="light-mode-switch">Light Mode</label>
                    </div>

                    <div class="mb-2">
                        <img src="assets/images/layouts/layout-2.jpg" class="img-fluid img-thumbnail" alt="">
                    </div>
                    <div class="custom-control custom-switch mb-3">
                        <input type="checkbox" class="custom-control-input theme-choice" id="dark-mode-switch"
                               data-bsStyle="assets/css/bootstrap-dark.min.css"
                               data-appStyle="assets/css/app-dark.min.css"/>
                        <label class="custom-control-label" for="dark-mode-switch">Dark Mode</label>
                    </div>

                    <div class="mb-2">
                        <img src="assets/images/layouts/layout-3.jpg" class="img-fluid img-thumbnail" alt="">
                    </div>
                    <div class="custom-control custom-switch mb-5">
                        <input type="checkbox" class="custom-control-input theme-choice" id="rtl-mode-switch"
                               data-appStyle="assets/css/app-rtl.min.css"/>
                        <label class="custom-control-label" for="rtl-mode-switch">RTL Mode</label>
                    </div>


                </div>

            </div> <!-- end slimscroll-menu-->
        </div>
        <!-- /Right-bar -->

        <!-- Right bar overlay-->
        <div class="rightbar-overlay"></div>
    </div>


    <div v-else>
        <Login/>
    </div>
</template>

<script>

    import Menu from "./Menu";
    import $ from "jquery";
    import t from "jquery";
    import {askForPermissioToReceiveNotifications} from '../service/firebase';
    import firebase from '../service/firebase';
    //import firebasesw from '../../public/firebase-messaging-sw';


    export default {
        name: "Blank",
        props: ['currentToken'],
        data() {
            return {
                isDashboard: true,
                user: JSON.parse(localStorage.getItem("user")),
                hasServiceWorker: false,
                token: ""
            }
        },
        mounted() {
            //initializeFirebase();
            
            this.worker();


        },
        methods: {

            worker() {
                if ('serviceWorker' in navigator) {
                    window.addEventListener('load', function () {
                        navigator.serviceWorker.register('../../firebase-messaging-sw.js')
                            .then((registration) => {
                                firebase.messaging.useServiceWorker(registration)
                                console.log("reg", registration);
                                askForPermissioToReceiveNotifications(this.user);
                                firebase.messaging.onMessage((payload) => {
                                    let data = JSON.parse(payload.data.notification);
                                    const notificationTitle = data.title + " ff";
                                    const notificationOptions = {
                                        body: data.body,
                                        icon: data.icon,
                                    };

                                    console.log("onM","pat");

                                    registration.showNotification(notificationTitle,
                                        notificationOptions,);
                                });
                            }).catch(err => {
                            console.log('error register', err)
                        })
                    });

                }
            },

            checkisDashboard(isDash) {
                this.isDashboard = isDash;
            },

            reloadpage(){
                location.reload();
            },
            resetDatas(component) {
                Object.assign(component.$data, component.$options.data.apply(component));
                component.loading = false;
            },
            menuAction() {
                $("body").toggleClass("sidebar-enable"), 992 <= $(window).width() ? $("body").toggleClass("vertical-collpsed") : $("body").removeClass("vertical-collpsed");
                t("#sidebar-menu a").each(function () {
                    var e = window.location.href.split(/[?#]/)[0];
                    this.href == e && (t(this).addClass("active"), t(this).parent().addClass("mm-active"), t(this).parent().parent().addClass("mm-show"), t(this).parent().parent().prev().addClass("mm-active"), t(this).parent().parent().parent().addClass("mm-active"), t(this).parent().parent().parent().parent().addClass("mm-show"), t(this).parent().parent().parent().parent().parent().addClass("mm-active"))
                }), t(".navbar-nav a").each(function () {
                    var e = window.location.href.split(/[?#]/)[0];
                    this.href == e && (t(this).addClass("active"), t(this).parent().addClass("active"), t(this).parent().parent().addClass("active"), t(this).parent().parent().parent().addClass("active"), t(this).parent().parent().parent().parent().addClass("active"), t(this).parent().parent().parent().parent().parent().addClass("active"))
                }), t('[data-toggle="fullscreen"]').on("click", function (e) {
                    e.preventDefault(), t("body").toggleClass("fullscreen-enable"), document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement ? document.cancelFullScreen ? document.cancelFullScreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : document.documentElement.requestFullscreen ? document.documentElement.requestFullscreen() : document.documentElement.mozRequestFullScreen ? document.documentElement.mozRequestFullScreen() : document.documentElement.webkitRequestFullscreen && document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
                }), t(".right-bar-toggle").on("click", function () {
                    t("body").toggleClass("right-bar-enabled")
                }), t(document).on("click", "body", function (e) {
                    0 < t(e.target).closest(".right-bar-toggle, .right-bar").length || t("body").removeClass("right-bar-enabled")
                }), t(".dropdown-menu a.dropdown-toggle").on("click", function () {
                    return t(this).next().hasClass("show") || t(this).parents(".dropdown-menu").first().find(".show").removeClass("show"), t(this).next(".dropdown-menu").toggleClass("show"), !1
                }), t(function () {
                    t('[data-toggle="tooltip"]').tooltip()
                }), t(function () {
                    t('[data-toggle="popover"]').popover()
                }), t("#light-mode-switch, #dark-mode-switch, #rtl-mode-switch").on("change", function (e) {
                    t(e.target.id)
                }), t(window).on("load", function () {
                    t("#status").fadeOut(), t("#preloader").delay(350).fadeOut("slow")
                });
            },
            logout() {

                let data = new FormData();
                data.append('email', this.email);
                data.append('password', this.password);
                this.$store.dispatch("auth/logout", data).then(response => {
                    window.console.log(response);
                    this.submitting = false;
                    if (response.error) {
                        this.state = 'error';
                        this.errors.login = response.message;
                    } else {
                        window.location = window.origin
                    }
                });
            },
        }
        ,
        components: {
            Menu
        }
    }
</script>

<style scoped>
    .v-application ul, .v-application ol {
        padding-left: 0px !important;
    }
</style>